import { atom } from "jotai";
import { LatestSession } from "../../@types/data";

export const latestSessionAtom = atom<LatestSession | null>(null);
